import React from 'react';
import styles from './NCBadge.module.css';

/**
 * NCBadge Component
 *
 * Displays an "NC" indicator for NC-routed projects with a tooltip
 * explaining the discount breakdown.
 *
 * @param {Object} props
 * @param {number} props.modelPrice - The client invoice amount
 * @param {number} props.tnRevenue - The TN received amount
 * @param {number} props.discountPercentage - The discount percentage (e.g., 15)
 * @param {string} props.size - Badge size: 'sm' | 'md'
 */
const NCBadge = ({ modelPrice, tnRevenue, discountPercentage, size = 'sm' }) => {
  if (!discountPercentage || discountPercentage <= 0) {
    return null;
  }

  const formatCurrency = (amount) => {
    if (amount == null) return 'TBD';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const tooltipText = `NC-routed: Client invoiced ${formatCurrency(modelPrice)}, TN receives ${formatCurrency(tnRevenue)} (${discountPercentage}% discount)`;

  return (
    <span
      className={`${styles.ncBadge} ${styles[size]}`}
      title={tooltipText}
    >
      NC
    </span>
  );
};

export default NCBadge;
